import { render, staticRenderFns } from "./collect-like.vue?vue&type=template&id=694a0fee&scoped=true"
import script from "./collect-like.vue?vue&type=script&lang=js"
export * from "./collect-like.vue?vue&type=script&lang=js"
import style0 from "./collect-like.vue?vue&type=style&index=0&id=694a0fee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694a0fee",
  null
  
)

export default component.exports